export default "__VITE_ASSET__aGOyS3El__";